import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {createFrom, EventService} from '@spartacus/core';
import {isPlatformBrowser} from '@angular/common';
import {Observable} from 'rxjs';
import {NavigationEvent} from '@spartacus/storefront';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {filter, map} from 'rxjs/operators';
import {CheckoutDataEntryPageEvent} from './checkout-data-entry-page-event';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class CheckoutDataEntryPageEventService {
  constructor(@Inject(PLATFORM_ID) public platformId: string, protected event: EventService) {
    this.register();
  }

  protected register(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.event.register(CheckoutDataEntryPageEvent, this.buildConfiguratorPageEvent());
  }

  protected buildConfiguratorPageEvent(): Observable<CheckoutDataEntryPageEvent> {
    return this.event.get(NavigationEvent).pipe(
      untilDestroyed(this),
      filter((navigationEvent) => navigationEvent.semanticRoute === 'checkoutDataEntry'),
      map((navigationEvent) =>
        createFrom(CheckoutDataEntryPageEvent, {
          navigation: navigationEvent,
        })
      )
    );
  }
}
